<template>
	<div class="cases-listings">
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">My Account</p>
					<h2 class="listing-title d-inline-block mb-0">Credit Balance</h2>
				</b-col>
				<!-- <b-col cols="6" class="text-right"> -->
				<b-col cols="6" class="text-right" v-if="auth_user.subscription.scrb_is_my_own || _gHlp.checkAccess(['allow_transfer_corp_credit'])">
					<b-button variant="primary" class="btn-header" @click="$refs.transfer_drawer.showDrawer()">Transfer Credit</b-button>
				</b-col>
			</b-row>
			<b-row class="d-flex justify-content-end mb-3">
					<b-col cols="auto" md="auto" class="float-left flex-grow-1 text-left">
							<span class="badge bg-fintos text-dark font-weight-600" v-if="!auth_user.subscription.scrb_is_my_own">You are currently using {{ auth_user.subscription.privileges.scpk_original_name }} subscription</span>
							<span class="badge bg-info text-dark font-weight-600" v-else>You are currently using your own {{ auth_user.subscription.privileges.scpk_original_name }} subscription</span>
					</b-col>
					<!-- <b-col cols="auto" md="auto" class="float-right text-right">
							<p>Total Available Requests</p>
							<h3 class="text-primary font-weight-600">{{ auth_user.subscription.scrb_credit_report }} reports</h3>
					</b-col> -->
					<b-col cols="auto" md="auto" class="float-right text-right">
							<p>Total Balance Points</p>
							<h3 class="text-primary font-weight-600">{{ auth_user.subscription.scrb_credit_points | moneyFormatter}}</h3>
					</b-col>
					<!-- <b-col cols="auto" md="auto" class="float-right text-right">
							<p>Total Balance Free Requests</p>
							<h3 class="text-primary font-weight-600">{{ auth_user.subscription.scrb_free_report }} reports</h3>
					</b-col> -->
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<b-card no-body class="px-3 pb-3">
				<el-tabs v-model="current_tab">
					<el-tab-pane label="Paid Report History" name="used-history">
						<span slot="label">
							<!-- House-building icon -->
							<b-icon icon="wallet" class="mr-1"></b-icon>
							Paid Reports
						</span>
						<BaseTableReportHistoryListing :listBaseTableReportHistory="creditBalanceHistoryList.filter((item) => item.cbh_credit_type != 'FREE_REPORT')" @filter_submit="filterSubmit($event)"/>
					</el-tab-pane>
					<!-- <el-tab-pane label="Credit History" name="topup-history">
						<span slot="label"> -->
							<!-- House-building icon -->
							<!-- <b-icon icon="wallet" class="mr-1"></b-icon>
							Free Requests
						</span>
						<BaseTableReportHistoryListing :listBaseTableReportHistory="creditBalanceHistoryList.filter((item) => item.cbh_credit_type == 'FREE_REPORT')" @filter_submit="filterSubmit($event)"/>
					</el-tab-pane> -->
				</el-tabs>
			</b-card>
		</b-container>
		<LoadingPage :is_loading="is_loading_page" />
		<TransferDrawer ref="transfer_drawer" @close="getHistory()"/>
	</div>
</template>
<script>
import BaseTableReportHistoryListing from '@/views/CreditReports/CreditBalance/Tables/BaseTableReportHistory/BaseTableReportHistoryListing'
import TransferDrawer from '@/views/CreditReports/CreditBalance/Drawers/TransferDrawer'
import { Tabs, TabPane } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useBillingStore } from '@/stores/billingStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import LoadingPage from '@/components/LoadingPage'

export default {
	components: {
		LoadingPage,
		TransferDrawer,
		BaseTableReportHistoryListing,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	data() {
		return {
			is_loading_page: false,
			current_tab: 'used-history',
			search: []
		}
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useBillingStore, ['creditBalanceHistoryList'])
	},
	async created() {
		this.is_loading_page = true;
		await this.getHistory();
	},
	mounted() {
		caseEventBus.$on('refresh-cases', this.getHistory);
		this.is_loading_page = false;
	},
	beforeUnmount() {
		EventBus.$off('refresh-cases', this.getHistory)
	},
	methods: {
		...mapActions(useBillingStore,['getCreditBalanceHistoryList']),
		...mapActions(useAccessControlStore,['getUsers']),
		getHistory() {
			try {
				let urlSearchParams = new URLSearchParams()
				// urlSearchParams.append('is_full_content', true)
				// urlSearchParams.append('pagination[limit]', 0)
				// urlSearchParams.append('pagination[order][prod_id]', 'DESC')
				urlSearchParams = this.getSearchParams(urlSearchParams);
				this.getCreditBalanceHistoryList(urlSearchParams);
			} catch (e) {
				this.errorFunction(e)
			}
		},
		filterSubmit(event) {
			this.search = event;
			this.getHistory();
		},
		getSearchParams(urlSearchParams) {
			if (this.isEmpty(this.search)) return urlSearchParams;
			let searchParams = this.search;
			for (const key in searchParams) {
				if (searchParams.hasOwnProperty(key)) {
					const value = searchParams[key];
					if (this.isEmpty(value)) {
						continue;
					}

					if (typeof value === 'object' && !Array.isArray(value)) {
						for (const subKey in value) {
							if (value.hasOwnProperty(subKey)) {
								urlSearchParams.append(`search[${key}][${subKey}]`, value[subKey]);
							}
						}
					} else {
						urlSearchParams.append(`search[${key}]`, value);
					}
				}
			}
			return urlSearchParams;
		}
	}
}
</script>